import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useAnalyticsContext } from 'src/common/metrics';
import { redirectToAmazonApp } from 'src/utils/redirectUtils';
import { RedirectingToAmazonPage } from './RedirectingToAmazonPage';
import { isBotTraffic } from './rumFilters';
// Sends the customer to the Amazon shopping app (mShop universal link) when the SMA
// app didn't hand off credentials. Rollout is via pipeline deployment; rollback is a CR
// revert or an Apollo emergency rollback.
export const MissingAuthPage = () => {
    const rumClient = useAnalyticsContext();
    useEffect(() => {
        if (!isBotTraffic()) {
            rumClient.recordEvent('MISSING_AUTH_PAGE_LOADED', {});
        }
        redirectToAmazonApp('missing_auth');
    }, [rumClient]);
    // The handoff asks the host SMA to open the link and does not navigate this page, so it stays
    // mounted until the host reacts. Render the interstitial rather than nothing.
    return _jsx(RedirectingToAmazonPage, { reason: "missing_auth" });
};
